import postMessageToParentExtension from '../utils/postMessageToParentExtension';
import { isNotificationEnabled } from 'extension-notification-setting';
import { MessageRequestTypes } from '../schema/RequestMessageTypes';

export const requestExtensionForPushSubscription = async (applicationServerKey: string) => {
    if (await isNotificationEnabled()) {
        postMessageToParentExtension({
            type: MessageRequestTypes.PushSubscriptionData,
            payload: { applicationServerKey },
        });
    }
};
